export default{
    authUser(state, userObj) {
        state.token = userObj.token;
        state.userName = userObj.username;
        state.parentEmail = userObj.parentemail;
        state.userId = userObj.userId;
        state.userProfileId = userObj.userProfileId;
        state.userType = userObj.userType;
        state.multiple_schools= userObj.multiple_schools
        state.didWatch = userObj.didWatchStory;
        state.schoolId = userObj.schoolId;
        state.firstName = userObj.firstName;
        state.LastName = userObj.lastName;
        state.hasVisitedIde = userObj.hasVisitedIde;
        state.isSchoolStudent = userObj.isSchoolStudent;
        if(userObj.parentProfileId){
            state.parentProfileId = userObj.parentProfileId;
        }
        state.img_uri =  userObj.img_uri;
    },
    clearAuthData(state) {
        state.token = null;
        state.userName = null;
        state.parentEmail = null;
        state.userId = null;
        state.parentProfileId = null;
        state.showTopTenModal = false;
        state.showCompetitionModal = false;
        state.userType = null;
        state.multiple_schools = true
        state.isFirstLogin = true;
        state.studentfinishFirstFreeLesson = false;
        state.studentfinishSecondFreeLesson = false;
        state.studentfinishThirdFreeLesson = false;
        state.studentfinishForthFreeLesson = false;
        state.studentfinishFifthFreeLesson = false;
        state.studentfinishBasicSmoothy = false;
        state.studentfinishIntermediateSmoothy = false;
        state.studentfinishAdvancedSmoothY = false;
        state.studentfinishExpertSmoothY = false;
        state.studentfinishHTML = false;
        state.subscribeNowDiscount = '';
        state.subscribePlanId = null;
        state.image_uri = null;
    },
    setMessage(state, mesObj) {
        state.message = mesObj;
    },
    loginMessage(state, mesObj) {
        state.loginMessage = mesObj;
    },
    clearMess(state) {
        state.message = {};
    },
    setCourseDetails(state, detailsObj) {
        state.courseDetails = detailsObj;
    },
    setCourseId(state,courseId){
        state.courseId = courseId;
    },
    setLessonPreVideo(state, lessonPreVideo) {
        state.lessonPreVideo = lessonPreVideo;
    },
    setAllowLessonLocking(state, allowLessonLocking) {
        state.allowLessonLocking = allowLessonLocking;
    },
    setAllowFinishLessons(state, allowfinishLessons) {
        state.allowfinishLessons = allowfinishLessons;
    },
    setIdeInfo(state, ideInfo) {
        state.ideInfo = ideInfo
    },
    setImageCateg(state, imageCateg) {
        state.imageCateg = imageCateg
    },
    setImagesByCategId(state, imagesByCateg) {
        state.imagesByCateg = imagesByCateg
    },
    setSoundCateg(state, soundCateg) {
        state.soundCateg = soundCateg
    },
    setSoundByCategId(state, soundsByCateg) {
        state.soundsByCateg = soundsByCateg
    },
    setStudentIndividualProject(state, studentIndividualProject) {
        state.studentIndividualProject = studentIndividualProject
    },
    setGraduationProject(state, graduationProject) {
        state.graduationProject = graduationProject
    },
    setGraduationProjectPlayground(state, graduationProject) {
        state.graduationProjectPlayground = graduationProject
    },
    setStudentCourseProject(state, studentCourseProjects) {
        state.studentCourseProjects = studentCourseProjects
    },
    setRandomCourseProject(state, randomCourseProject){
        state.randomCourseProject = randomCourseProject;
    },
    setStudentType(state, StudentType){
        state.StudentType = StudentType;
    },
    setSetStudentActiveCourseInfo(state, activeCourse){
        state.activeCourse = activeCourse;
    },
    setSubscriptionPlan(state, planObj){
        state.planObj = planObj;
    },
    setCompetitionPlan(state,competitionPlan) {
        state.competitionPlan = competitionPlan
    },
    isGoalVisited(state, flag){
        state.isGoalVisited = flag;
    },
    setIdeVisited(state,isVisited){
        state.isVisited = isVisited;
    },
    hasIdeVisited(state,hasVisited){
        state.hasVisitedIde = hasVisited;
    },
    incrementPointsbyValue(state,value){
        state.points += value;
    },
    setPointstoZero(state,value){
        state.points = value;
    },
    showTopTenModal(state,value){
        state.showTopTenModal = value;
    },
    showCompetitionModal(state,value){
        state.showCompetitionModal = value;
    },
    setShowWhatsAppModal(state,value){
        state.WhatsApp = value;
    },
    setIsTrial(state,value){
        state.isTrial = value
    },
    setCompetetionInfo(state, competitionInfo){
        state.competitionInfo = competitionInfo;
    },
    setIsFirstLogin(state,isFirstLogin){
        state.isFirstLogin = isFirstLogin
    },
    setStudentfinishFirstFreeLesson(state,studentfinishFirstFreeLesson){
        state.studentfinishFirstFreeLesson = studentfinishFirstFreeLesson
    },
    setStudentfinishSecondFreeLesson(state,studentfinishSecondFreeLesson){
        state.studentfinishSecondFreeLesson = studentfinishSecondFreeLesson
    },
    setStudentfinishThirdFreeLesson(state,studentfinishThirdFreeLesson){
        state.studentfinishThirdFreeLesson = studentfinishThirdFreeLesson
    },
    setStudentfinishForthFreeLesson(state,studentfinishForthFreeLesson){
        state.studentfinishForthFreeLesson = studentfinishForthFreeLesson
    },
    setStudentfinishFifthFreeLesson(state,studentfinishFifthFreeLesson){
        state.studentfinishFifthFreeLesson = studentfinishFifthFreeLesson
    },
    setIsComeFromGrants(state,isComeFromGrants){
        state.isComeFromGrants = isComeFromGrants
    },
    setSubscribeNowDiscount(state,discountCode){
        state.subscribeNowDiscount = discountCode
    },
    setSubscribePlanId(state,plan){
        state.subscribePlanId = plan
    },
    setCliantInfo(state,cliantInfo){
        state.cliantInfo = cliantInfo
    },
    setFirstName(state,firstName){
        state.firstName = firstName
    },
    setLastName(state,LastName){
        state.LastName = LastName
    },
    setStudentfinishBasicSmoothy(state,studentfinishBasicSmoothy){
        state.studentfinishBasicSmoothy = studentfinishBasicSmoothy
    },
    setStudentfinishIntermediateSmoothy(state,studentfinishIntermediateSmoothy){
        state.studentfinishIntermediateSmoothy = studentfinishIntermediateSmoothy
    },
    setStudentfinishAdvancedSmoothY(state,studentfinishAdvancedSmoothY){
        state.studentfinishAdvancedSmoothY = studentfinishAdvancedSmoothY
    },

    setStudentfinishExpertSmoothY(state,studentfinishExpertSmoothY){
        state.studentfinishExpertSmoothY = studentfinishExpertSmoothY
    },
    setStudentfinishHTML(state,studentfinishHTML){
        state.studentfinishHTML = studentfinishHTML
    },
    setStudentIec(state,student_iec){
      state.student_iec=student_iec
    },
    setImageEmoji(state, img_uri){
        state.img_uri = img_uri
    },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js